/* eslint-disable @typescript-eslint/no-explicit-any */
import { Select as SelectBase } from 'antd';
import { SelectProps } from 'antd/lib/select';
import { theme } from 'configs/styled';
import React from 'react';

export interface ISelectOptionProps {
  title: string;
  value: string | number;
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export interface ISelectProps extends SelectProps<any> {
  options: ISelectOptionProps[];
  icon?: React.ReactNode;
  fontFamily?: string;
}

const Select: React.FC<ISelectProps> = ({
  fontFamily = theme.fonts.NotoSansTh,
  options,
  ...props
}) => {
  const preserveSearchSelection = (event: React.FormEvent<HTMLSpanElement>) => {
    const input = event.target as HTMLInputElement;
    if (!input.classList.contains('ant-select-selection-search-input')) return;

    const container = event.currentTarget;
    const inputEvent = event.nativeEvent as InputEvent;
    const isComposing =
      inputEvent.isComposing ||
      inputEvent.inputType === 'insertCompositionText';
    const selectionStart = isComposing
      ? input.value.length
      : input.selectionStart;
    const selectionEnd = isComposing ? input.value.length : input.selectionEnd;
    if (selectionStart === null || selectionEnd === null) return;

    // rc-select 10 re-renders its controlled search input on every keystroke.
    // Android IMEs can report the caret at the start while composing Thai
    // text. Composition input always appends to this search box, so restore
    // it to the end; otherwise preserve the user's exact selection.
    window.setTimeout(() => {
      const currentInput = container.querySelector<HTMLInputElement>(
        '.ant-select-selection-search-input',
      );
      currentInput?.setSelectionRange(selectionStart, selectionEnd);
    }, 0);
  };

  return (
    <span
      onInputCapture={preserveSearchSelection}
      style={{ display: 'contents' }}
    >
      <SelectBase {...props} optionLabelProp="title">
        {options.map((option, idx) => {
          const { title, value, style, disabled, ...rest } = option;
          let color = theme.palettes.black85;
          if (disabled) {
            color = theme.palettes.black40;
          }

          return (
            <SelectBase.Option
              style={{ fontFamily, color, ...style }}
              key={`${value}-${idx}`}
              value={value}
              title={title}
              disabled={disabled}
              {...rest}
            >
              {title}
              {props.value === value && props.icon}
            </SelectBase.Option>
          );
        })}
      </SelectBase>
    </span>
  );
};

export default Select;
